import React from 'react';
import classNames from 'classnames';

import './AnimatedBackground.scss';

type AnimatedBackgroundProps = {
  children: React.ReactNode;
  paused?: boolean;
  className?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>['className'];
};

export const AnimatedBackground = React.forwardRef(
  ({ className, paused, children }: AnimatedBackgroundProps, ref: React.Ref<HTMLDivElement>) => {
    return (
      <div
        ref={ref}
        className={classNames(className, 'animated-background', { 'animated-background--paused': paused })}
      >
        {children}
      </div>
    );
  }
);
